import React from "react";

const MainModalHeader = ({ header, icon, closeModalHandler }) => {
    return (
        <>
            <div className="modal-header flex items-center justify-between">
                <header className="main-model-form-header main-content-header flex items-center">
                    {icon && <i className={`${icon}`}></i>}
                    <h3>{header}</h3>
                </header>
                {closeModalHandler && (
                    <div
                        onClick={closeModalHandler}
                        className="icon-wrapper ml-auto mt-1"
                    >
                        <i className="fas fa-times" />
                    </div>
                )}
            </div>
        </>
    );
};

export default MainModalHeader;
